import type { ReactNode } from "react";
import styles from "./FieldHint.module.css";

interface FieldHintProps {
  children: ReactNode;
  id?: string;
}

export default function FieldHint({ children, id }: FieldHintProps) {
  return (
    <p className={styles.hint} id={id}>
      {children}
    </p>
  );
}
